var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgImagethumbnail(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 17,
    height: 15,
    viewBox: "0 0 17 15",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M12.2883 2.52499C13.3481 2.52499 14.2065 3.38331 14.2065 4.44214C14.2065 5.50098 13.3481 6.3603 12.2883 6.3603C11.2295 6.3603 10.3712 5.50098 10.3712 4.44214C10.3712 3.38331 11.2295 2.52499 12.2883 2.52499ZM5.97045 5.54313C6.08174 5.54313 6.18302 5.58825 6.25622 5.66044L9.3665 8.77279L10.7592 7.37905C10.8324 7.29482 10.9407 7.24068 11.0611 7.24068H11.0651L11.0661 7.23967H11.0681V7.23867C11.1794 7.23867 11.2806 7.28379 11.3538 7.35599L14.8774 10.8824C14.9466 10.9556 14.9897 11.0548 14.9897 11.1641V12.964C14.9897 13.1896 14.8062 13.3731 14.5796 13.3741L2.81096 13.3731C2.70267 13.3731 2.59839 13.3299 2.52119 13.2537C2.44498 13.1765 2.40086 13.0723 2.40086 12.964L2.40287 9.10671C2.40488 8.99742 2.44899 8.89816 2.52018 8.82595L5.6605 5.6846C5.7347 5.60038 5.84199 5.54623 5.96232 5.54623H5.96332L5.96633 5.54523H5.97034L5.97045 5.54313ZM15.2292 0.725098H2.1612C1.48439 0.725098 0.935922 1.26856 0.931892 1.94537V13.6398C0.935903 14.3166 1.48436 14.8601 2.1612 14.8611H15.2292C15.906 14.8601 16.4545 14.3166 16.4585 13.6398V1.94537C16.4545 1.26856 15.906 0.725098 15.2292 0.725098Z",
    fill: "#787777"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgImagethumbnail);
export default __webpack_public_path__ + "static/media/imagethumbnail.0efb8371c187d7be1388952f30521a39.svg";
export { ForwardRef as ReactComponent };